import {formatterInteger} from './../utils';

// eslint-disable-next-line require-jsdoc
export default function (el, binding, vNode) {
  const bindValue = binding.value;
  const ele = el.tagName === 'INPUT' ? el : el.querySelector('input');
  let val = '';
  if (vNode.data && vNode.data.model) {
    val = vNode.data.model.value;
  } else {
    val = ele.value;
  }
  const defaultNum = 2;
  val = formatterInteger(val, bindValue && bindValue.num || defaultNum);
  ele.value = val;
  ele.dispatchEvent(new Event('input'));
}

